<div class="space-y-3">
  <div *ngFor="let video of videos"
       (click)="openVideo(video)"
       class="flex items-center justify-between p-4 bg-white border border-gray-200 rounded-xl cursor-pointer hover:border-[#1D4586] hover:shadow-sm transition-all">
    <div class="flex items-center gap-4">
      <div class="w-8 h-8 rounded-full bg-[#E9F0E6] flex items-center justify-center text-[#1D4586]">
        <svg class="w-4 h-4 ml-0.5" fill="currentColor" viewBox="0 0 20 20"><path d="M4 4l12 6-12 6V4z"/></svg>
      </div>
      <span class="font-medium text-gray-800">{{ video.title }}</span>
    </div>
    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
  </div>
</div>